
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[collectionHandle]",
      function () {
        return require("private-next-pages/collections/[collectionHandle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[collectionHandle]"])
      });
    }
  